<template>
  <ul class="quiz-colors">
        <li>
            <input type="radio" name="quiz-color-option" value="#FDB322" id="QCOrange" v-model="selectedColor">
            <label for="QCOrange"></label>
        </li>
        <li>
            <input type="radio" name="quiz-color-option" value="#FF6464" id="QCRed" checked v-model="selectedColor">
            <label for="QCRed"></label>
        </li>
        <li>
            <input type="radio" name="quiz-color-option" value="#933EFF" id="QCPurple" v-model="selectedColor">
            <label for="QCPurple"></label>
        </li>
        <li>
            <input type="radio" name="quiz-color-option" value="#0F6FFF" id="QCBlue" v-model="selectedColor">
            <label for="QCBlue"></label>
        </li>
        <li>
            <input type="radio" name="quiz-color-option" value="#0FF0FF" id="QCTurcoaz" v-model="selectedColor">
            <label for="QCTurcoaz"></label>
        </li>
    </ul>
</template>

<script>
export default {
    name: "formColorSelector",
    props: {
        initialColor: String
    },
    data() {
        return {
            selectedColor: ""
        }
    },
    mounted() {
        this.selectedColor = this.initialColor;
    },
    watch: {
        selectedColor: function(val) {
            this.$emit('selectedColor', val);
        }
    }
}
</script>

<style>

</style>